module.exports = __webpack_public_path__ + "img/info-card.c71cf93e.svg";